export default "__VITE_ASSET__vmN3Vanw__"